import type {
  ActionReducerMapBuilder,
  AsyncThunk,
  Draft
} from "@reduxjs/toolkit"

type BooleanKeys<T> = {
  [K in keyof T]: T[K] extends boolean ? K : never
}[keyof T]

const addPrimitiveCases = <TState extends Record<string, any>, TResult>(
  builder: ActionReducerMapBuilder<TState>,
  thunk: AsyncThunk<TResult, any, any>,
  key: BooleanKeys<TState>
) => {
  builder
    .addCase(thunk.pending, (state: Draft<TState>) => {
      state[key as keyof Draft<TState>] =
        true as Draft<TState>[keyof Draft<TState>]
    })
    .addCase(thunk.fulfilled, (state: Draft<TState>) => {
      state[key as keyof Draft<TState>] =
        false as Draft<TState>[keyof Draft<TState>]
    })
    .addCase(thunk.rejected, (state: Draft<TState>) => {
      state[key as keyof Draft<TState>] =
        false as Draft<TState>[keyof Draft<TState>]
    })
}

export { addPrimitiveCases }
